export function preventDefault(callback: () => void) {
  return (e: React.MouseEvent) => {
    e.preventDefault()
    callback()
  }
}
